import _ from 'lodash';
import {log} from 'common/log';

export function validateNotiUrlAction(action: string) {
	if (!_.startsWith(action, 'http')) {
		log.warn('url does not start with http:// or https:// and therefore redirect will not work');
	}
}